import {
  STATUSES,
  makeListState,
  makeDataState,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  coinItems: makeListState(),
  balloonItems: makeListState(),
  payment: makeDataState(),
  episodePurchaseInfo: makeDataState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch payment items
    case `${t.FETCH_PAYMENT_COIN_ITEMS}_PENDING`:
      return {
        ...state,
        coinItems: {
          ...state.coinItems,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };
    case `${t.FETCH_PAYMENT_COIN_ITEMS}_SUCCESS`:
      return {
        ...state,
        coinItems: {
          ...state.coinItems,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_PAYMENT_COIN_ITEMS}_ERROR`:
      return {
        ...state,
        coinItems: {
          ...state.coinItems,
          status: STATUSES.ERROR,
        },
      };

    // fetch payment pt items
    case `${t.FETCH_PAYMENT_BALLOON_ITEMS}_PENDING`:
      return {
        ...state,
        balloonItems: {
          ...state.balloonItems,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };
    case `${t.FETCH_PAYMENT_BALLOON_ITEMS}_SUCCESS`:
      return {
        ...state,
        balloonItems: {
          ...state.balloonItems,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_PAYMENT_BALLOON_ITEMS}_ERROR`:
      return {
        ...state,
        balloonItems: {
          ...state.balloonItems,
          status: STATUSES.ERROR,
        },
      };

    // verify payment
    case `${t.VERIFY_PAYMENT}_SUCCESS`:
      return {
        ...state,
        payment: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.VERIFY_PAYMENT}_ERROR`:
      return {
        ...state,
        payment: {
          ...state.payment,
          status: STATUSES.ERROR,
        },
      };

    case t.USE_IN_APP_PURCHASE:
      return {
        ...state,
        payment: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: {
            pgType: action.meta.pgType,
            price: action.meta.price,
            itemType: action.meta.type,
            itemQuantity: action.meta.quantity,
            itemDescription: action.meta.description,
            transactionId: action.meta.transactionId,
            itemBonusType: action.meta.bonusType,
            itemBonusQuantity: action.meta.bonusQuantity,
            status: 'paid',
            paidAt: action.meta.paidAt,
          },
        },
      };

    case `${t.FETCH_PURCHASE_INFO}_PENDING`:
      return {
        ...state,
        episodePurchaseInfo: {
          ...state.episodePurchaseInfo,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_PURCHASE_INFO}_SUCCESS`:
      return {
        ...state,
        episodePurchaseInfo: {
          ...state.episodePurchaseInfo,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_PURCHASE_INFO}_ERROR`:
      return {
        ...state,
        episodePurchaseInfo: {
          ...state.episodePurchaseInfo,
          status: STATUSES.ERROR,
        },
      };

    // reset purchase info
    case t.RESET_PURCHASE_INFO:
      return {
        ...state,
        episodePurchaseInfo: makeDataState(),
      };

    // reset
    case t.RESET:
      return {
        ...state,
        payment: makeDataState(),
      };

    default:
      return { ...state };
  }
};
export { initialState };



// WEBPACK FOOTER //
// ./src/app/redux/front/store/reducer.js